<template>
    <div>
        <div class="card" style="height:700px!important">
            <div id="loadingmessage"
                style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
                v-if="loading">
                <p style="position: absolute; color: White; top: 40%; left: 50%;">
                    <img src="../../assets/loader.gif" />
                </p>
            </div>
          
            <div class="listing-section pt-3 pl-3">
                <h3 class="listing-desc-headline margin-top-60" style="font-weight:400!important;margin-bottom:30px">
                    Sightings Location</h3>
                <div id="myMap"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    var marker
    export default {

        data() {
            return {
                loading: false,
                data: [],
              
            }
        },
        mounted: function () {
            this.getList()
        },
     
        methods: {
            getList() {
                this.loading = true
                var att = {}
               
                att['token'] = localStorage.getItem('token')
                axios({
                    method: 'GET',
                    url: '/dashboard/admin',
                    data: att,
                })
                    .then(response => {
                        // console.log(response.data.data)

                        this.loading = false
                        if (response.data.status === true) {
                            this.data = response.data.data.sightings
                            var mapCanvas = document.getElementById('myMap')

                            var mapOptions = {

                                center: new google.maps.LatLng(18.53766, 76.884773),
                                zoom: 4,

                                mapTypeId: google.maps.MapTypeId.TERRAIN
                            }
                            var vm = this

                            vm.map = new google.maps.Map(mapCanvas, mapOptions);

                            // var data = {};

                            for (var i = 0; i < this.data.length; i++) {
                                var lat = this.data[i].location[1]
                                var lon = this.data[i].location[0]


                                var latlngset = new google.maps.LatLng(lat, lon);
                                if (this.data[i].purpose === 'observation') {
                                    var iconBase = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                                }
                                if (this.data[i].purpose === 'rescue') {
                                    var iconBase = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
                                }

                                marker = new google.maps.Marker({
                                    map: vm.map,
                                    position: latlngset,

                                    icon: iconBase
                                })
                                // vm.Marker[i] = {
                                //   m: marker,

                                // }

                                var content =
                                    '<table><tr><td colspan=2 style="padding-left:10px;"><p style="color:#ff6907;">Purpose: ' + this.data[i].purpose +
                                    '</p><p><a style="color:#333333">state: ' + this.data[i].state +
                                    '</a></p></td></tr></table>'

                                var infowindow = new google.maps.InfoWindow();

                                google.maps.event.addListener(
                                    marker,
                                    'click',
                                    (function (marker, content, infowindow) {
                                        return function () {
                                            infowindow.setContent(content)
                                            infowindow.open(vm.map, marker)
                                        }
                                    })(marker, content, infowindow)
                                )

                                this.loading = false
                            }
                        } else if (response.data.status === false) {
                            this.loading = false
                        }
                    })
                    .catch(e => {
                        console.log(e)
                        this.loading = false
                        // this.errors.push(e)
                        // this.msg = 'failed'
                    })
            },
        },
    }
</script>
<style>
    #myMap {
        height: 500px !important;
        width: 100%;
    }
</style>